onComplete(function () {

	const navHeader = document.querySelector('.nav-header');

	const isMobile = window.matchMedia("(max-width: 991px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 150 : 200;

	if (navHeader) {
		window.addEventListener('scroll', () => {
			const scroll = window.pageYOffset || document.documentElement.scrollTop;

			if (scroll >= PAGE_SCROLL_THRESHOLD) {
				navHeader.classList.add('scroll');
			} else {
				navHeader.classList.remove('scroll');
			}
		})
	}

});